import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, CheckSquare, TrendingUp, Palette, FileText,
  Megaphone, BarChart3, Store, Sliders, CreditCard, Bot, Wallet, Boxes,
} from "lucide-react";

const NAV = [
  { to: "/", label: "Overview & Control", icon: LayoutDashboard, end: true, key: "overview" },
  { to: "/vault", label: "AI Vault", icon: Boxes, key: "vault" },
  { to: "/queue", label: "Review Queue", icon: CheckSquare, key: "queue" },
  { to: "/research", label: "Niche & Trends", icon: TrendingUp, key: "research" },
  { to: "/designs", label: "Design Studio", icon: Palette, key: "designs" },
  { to: "/listings", label: "Listing Writer", icon: FileText, key: "listings" },
  { to: "/ads", label: "Ad Campaigns", icon: Megaphone, key: "ads" },
  { to: "/analytics", label: "Profit & Performance", icon: BarChart3, key: "analytics" },
  { to: "/wallet", label: "Wallet & Payouts", icon: Wallet, key: "wallet" },
  { to: "/stores", label: "Connected Stores", icon: Store, key: "stores" },
  { to: "/settings", label: "Trust & Autonomy", icon: Sliders, key: "settings" },
  { to: "/billing", label: "Billing", icon: CreditCard, key: "billing" },
];

export default function Sidebar({ pendingCount = 0 }) {
  return (
    <aside className="fixed left-0 top-0 bottom-0 w-64 bg-[#0C0F14] border-r border-slate-800/80 z-40 flex flex-col">
      <div className="h-16 flex items-center gap-2.5 px-5 border-b border-slate-800/80">
        <div className="w-8 h-8 rounded-lg bg-emerald-500 flex items-center justify-center shadow-[0_0_18px_rgba(16,185,129,0.4)]">
          <Bot className="w-5 h-5 text-slate-950" />
        </div>
        <div className="leading-tight">
          <div className="font-head font-bold text-slate-100 text-sm">AutoStore AI</div>
          <div className="text-[10px] text-slate-500 font-mono uppercase tracking-wider">Operator Console</div>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1">
        {NAV.map((n) => (
          <NavLink
            key={n.key}
            to={n.to}
            end={n.end}
            data-testid={`nav-${n.key}`}
            className={({ isActive }) =>
              `group flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all duration-200 ${
                isActive
                  ? "bg-emerald-500/10 text-emerald-300 border border-emerald-500/30"
                  : "text-slate-400 hover:text-slate-100 hover:bg-slate-800/50 border border-transparent"
              }`
            }
          >
            <n.icon className="w-[18px] h-[18px] shrink-0" />
            <span className="truncate">{n.label}</span>
            {n.key === "queue" && pendingCount > 0 && (
              <span className="ml-auto text-[10px] font-mono px-1.5 py-0.5 rounded bg-amber-500/20 text-amber-300 border border-amber-500/30">
                {pendingCount}
              </span>
            )}
          </NavLink>
        ))}
      </nav>
      <div className="p-4 border-t border-slate-800/80 text-[11px] text-slate-600 font-mono">
        v1.0 · POD Autopilot
      </div>
    </aside>
  );
}
